/** @file Length of an animation in frames: durationFrames, else its last key (the compiler's rule). */
import { lastKeyFrame } from '@pose2d/compiler/compile/lastKeyFrame';
import type { AnimationDoc } from '@pose2d/format/types';

/** `durationFrames` when set, else the last keyed frame (0 for an empty animation), as compileAnimations reads it. */
export function animationFrames(anim: AnimationDoc): number {
  return anim.durationFrames ?? lastKeyFrame(anim);
}
